"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));

var _api = require("@lce/api");

var _integrations = require("@sentry/integrations");

var _browser = require("@sentry/browser");

var _tracing = require("@sentry/tracing");

var _concat = _interopRequireDefault(require("lodash/concat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable @typescript-eslint/no-explicit-any */


var useSentry = function useSentry(version) {
  var settings = (0, _api.useSettings)().data;
  var client = new _browser.BrowserClient({
    dsn: 'https://baaa04ffb97b43deb9b10445ac299ec7@o270910.ingest.sentry.io/5864882',
    environment: settings === null || settings === void 0 ? void 0 : settings.CONFIG.SENTRY.ENVIRONMENT,
    release: "" + version,
    debug: settings === null || settings === void 0 ? void 0 : settings.CONFIG.SENTRY.DEBUG,
    integrations: (0, _concat["default"])(_browser.defaultIntegrations, new _tracing.Integrations.BrowserTracing(), new _integrations.CaptureConsole({
      levels: ['error']
    })),
    ignoreErrors: ['Non-Error promise rejection captured', /Blocked a frame with origin/, /Unexpected token '<'/],
    tracesSampler: function tracesSampler(samplingContext) {
      var _a, _b;

      if (!(0, _includes2["default"])((_b = (_a = settings === null || settings === void 0 ? void 0 : settings.CONFIG) === null || _a === void 0 ? void 0 : _a.SENTRY) === null || _b === void 0 ? void 0 : _b.SKIP_TRANSACTION_ROUTES, samplingContext.transactionContext.name) && (settings === null || settings === void 0 ? void 0 : settings.CONFIG.SENTRY.TRANSACTIONS) || undefined) {
        return (0, _toNumber2["default"])(settings === null || settings === void 0 ? void 0 : settings.CONFIG.SENTRY.TRACE_SAMPLE_RATE);
      } else {
        return 0;
      }
    },
    beforeSend: function beforeSend(event) {
      if (event === null || event === void 0 ? void 0 : event.exception) {
        (settings === null || settings === void 0 ? void 0 : settings.FEATURE.SENTRY) && (settings === null || settings === void 0 ? void 0 : settings.FEATURE.SHOW_FEEDBACK_DIALOG) && (0, _browser.showReportDialog)({
          eventId: event.event_id
        });
      }

      return (settings === null || settings === void 0 ? void 0 : settings.FEATURE.SENTRY) ? event : null;
    }
  });
  (0, _browser.getCurrentHub)().bindClient(client);
  return {
    hub: (0, _browser.getCurrentHub)()
  };
};

var _default = useSentry;
exports["default"] = _default;